import React from "react";

import PrismicImgix from "@sendmagic/prismic-nextjs/src/components/Imgix";
import PrismicLinkTag from "@sendmagic/prismic-nextjs/src/components/LinkTag";

import { checkContentPresence } from "@sendmagic/prismic-nextjs/src/helpers/prismic";
import { textResolver } from "@sendmagic/prismic-nextjs/src/constants/text-resolver";

import defaultStyles from "./main.module.scss";

const TwoImageRowWithTwoCTA = ({
  doc,
  sliceStyles: styles = defaultStyles,
  trackOnClickEvents,
}) => {
  const { header, description } = doc?.primary || {};

  return (
    <div className={styles.twoImageRowWrapper}>
      <div className={styles.imageConatiner}>
        {checkContentPresence(header) && (
          <h2 className={styles.headerHeading}>
            {textResolver(header, { convertLabelToModular: true, convertToNormalText: true })}
          </h2>
        )}
        {checkContentPresence(description) && (
          <div className={styles.slideDescription}>
            {textResolver(description, { convertLabelToModular: true })}
          </div>
        )}

        <div className={styles.twoImageHolder}>
          {doc?.items?.map(
            ({
              image,
              image_header,
              image_description,
              left_link,
              left_link_text,
              right_link,
              right_link_text,
            }) => (
              <div className={styles.twoImageBlock} key={image?.url}>
                {image?.url && (
                  <div className={styles.imageWrapper}>
                    <PrismicImgix
                      className={styles.mainImage}
                      src={image?.url}
                      alt={image?.alt}
                      desktop="250px"
                      mobile="150px"
                      tablet="120px"
                      largeDisplay="500px"
                    />
                  </div>
                )}
                <div className={styles.textContainer}>
                  {checkContentPresence(image_header) && (
                    <h2 className={styles.twoImageTitle}>
                      {textResolver(image_header, {
                        convertLabelToModular: true,
                        convertToNormalText: true,
                      })}
                    </h2>
                  )}
                  {checkContentPresence(image_description) && (
                    <div className={styles.imageDescription}>
                      {textResolver(image_description, { convertLabelToModular: true })}
                    </div>
                  )}
                </div>
                <div className={styles.TwoCtaWrapper}>
                  {left_link?.url && (
                    <div className={styles.lernMoreCtaBlock}>
                      <PrismicLinkTag
                        urlText={left_link_text}
                        url={left_link?.url}
                        target={left_link?.target}
                        className={styles.learnMoreBtn}
                        convertLabelToModular
                      />
                    </div>
                  )}
                  {right_link?.url && (
                    <div
                      className={styles.bookACallBtnBlock}
                      onClick={() => trackOnClickEvents?.({ target: right_link_text })}
                    >
                      <PrismicLinkTag
                        urlText={right_link_text}
                        url={right_link?.url}
                        target={right_link?.target}
                        className={styles.bookACallBtn}
                        convertLabelToModular
                      />
                    </div>
                  )}
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default TwoImageRowWithTwoCTA;
